import { RadioGroup } from "@outschool/backpack";
import { Search as SearchFilters } from "@outschool/business-rules";
import { SearchFilters as SearchFiltersType } from "@outschool/gql-backend-generated";
import { useTranslation } from "@outschool/localization";
import { Filter, FilterList } from "@outschool/ui-components-website";
import React, { useCallback, useState } from "react";

import FilterActionButtons from "./desktop/FilterActionButtons";

type CapacityFilterProps = {
  handleChangesExternally?: boolean;
  onCancel: () => void;
  onChange: (value: $TSFixMe) => void;
  value: SearchFiltersType;
};

export const useCapacityToString = (): ((args: {
  capacityMin?: number;
  capacityMax?: number;
}) => string) => {
  const { t } = useTranslation("client\\components\\search\\CapacityFilter");
  return useCallback(
    ({
      capacityMin,
      capacityMax
    }: {
      capacityMin?: number;
      capacityMax?: number;
    }) => {
      if (capacityMin && capacityMax) {
        return t("{{capacityMin}}-{{capacityMax}} learners", {
          capacityMin,
          capacityMax
        });
      }
      if (capacityMin) {
        return t("{{capacityMin}}+ learners", { capacityMin });
      }
      if (capacityMax) {
        return capacityMax === 1
          ? t("1 learner")
          : t("Up to {{capacityMax}} learners", { capacityMax });
      }
      return t("Any");
    },
    [t]
  );
};

// NOTE: ClassSizeFilter in the Search page is very similar to this, consolidate it in the future.
export default function CapacityFilter({
  handleChangesExternally,
  onCancel,
  onChange,
  value
}: CapacityFilterProps) {
  const { t } = useTranslation("client\\components\\search\\CapacityFilter");
  const [capacity, setCapacity] = useState(JSON.stringify(value) || {});
  const displayCapacityString = useCapacityToString();

  const handleFilterChange = (_e: any, value: string) => {
    const valueObject: SearchFiltersType = JSON.parse(value);
    setCapacity(valueObject);
    if (handleChangesExternally) {
      onChange(valueObject);
    }
  };

  return (
    <FilterList>
      <Filter title={t("Class size")}>
        <RadioGroup
          name="capacity"
          value={JSON.stringify(capacity)}
          options={SearchFilters.CAPACITY_OPTIONS.map(capacityOption => ({
            label: displayCapacityString(capacityOption),
            value: JSON.stringify(capacityOption)
          }))}
          onChange={handleFilterChange}
        />
      </Filter>
      {handleChangesExternally ? null : (
        <FilterActionButtons
          onApply={() => onChange(capacity)}
          onCancel={onCancel}
        />
      )}
    </FilterList>
  );
}
